import { render } from "./Navigasi.vue?vue&type=template&id=a6c353cc&ts=true"
import script from "./Navigasi.vue?vue&type=script&lang=ts"
export * from "./Navigasi.vue?vue&type=script&lang=ts"

import exportComponent from "/home/dajetmiko/react/admin.animemo.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__